export default "__VITE_ASSET__uP3OZJ85__"